import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { contentRoutes } from '../../contentRoutes';

const Breadcrumb = () => {
    const location = useLocation();
    const findRoute = (path: string, routes: any[]): any => {
        const parts = path.split('/');
        if (!isNaN(Number(parts[parts.length - 1]))) {
            parts[parts.length - 1] = '*';
            path = parts.join('/');
        }
        for (let route of routes) {
            let routePath = '';
            let partsRouter: any = route.path ? route?.path.split('/') : '';
            if (partsRouter[partsRouter.length-1] === ':id'){
                routePath = route?.path.replace(/:\w+/g, '*');
            }else{
                routePath = route?.path
            }
            if (routePath === path) {
                return route;
            }
            if (route.children) {
                const childRoute = findRoute(path, route.children);
                if (childRoute) return childRoute;
            }
        }
        return null;
    };

    const generateBreadcrumbs = () => {
        const breadcrumbs: JSX.Element[] = [];
        const paths = location.pathname.split('/').filter(x => x);
        let currentPath = '';

        paths.forEach((path, index) => {
            currentPath += `/${path}`;
            const route = findRoute(currentPath, contentRoutes);
            if (route) {
                breadcrumbs.push(
                    <li key={index}>
                        <Link to={currentPath}>{route.description}</Link>
                    </li>
                );
            }
        });

        return breadcrumbs;
    };

    const crumbs = generateBreadcrumbs();

    return (
        <nav>
            <ul style={{display: 'flex', alignItems: 'center', listStyleType: 'none', padding: 0, margin: 0, gap: 6}}>
                {crumbs.map((breadcrumb, index) => {
                    const isLast = index === crumbs.length - 1;
                    return (
                        <React.Fragment key={index}>
                            <li style={{
                                fontSize: 13,
                                fontWeight: isLast ? 600 : 400,
                                color: isLast ? '#2d3748' : '#94a3b8',
                                cursor: isLast ? 'default' : 'pointer',
                                pointerEvents: isLast ? 'none' : 'auto',
                                whiteSpace: 'nowrap',
                            }}>
                                <span style={{textDecoration: 'none'}}>{breadcrumb}</span>
                            </li>
                            {!isLast && (
                                <span style={{color: '#a0aec0', fontSize: 18, userSelect: 'none', fontWeight: 300, display: 'inline-block', verticalAlign: 'middle', marginTop: -2}}>›</span>
                            )}
                        </React.Fragment>
                    );
                })}
            </ul>
        </nav>
    );
};

export default Breadcrumb;